import { render, staticRenderFns } from "./historicalAddresses.vue?vue&type=template&id=79d5d212&scoped=true&"
import script from "./historicalAddresses.vue?vue&type=script&lang=js&"
export * from "./historicalAddresses.vue?vue&type=script&lang=js&"
import style0 from "./historicalAddresses.vue?vue&type=style&index=0&id=79d5d212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d5d212",
  null
  
)

export default component.exports